var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.oldestDeprecatedInvoice)?_c('v-card',{attrs:{"to":{
		name: 'invoice',
		params: { id: _vm.oldestDeprecatedInvoice.invoice.id },
	}}},[_c('v-alert',{staticClass:"mt-0 mb-3",attrs:{"type":"error","prominent":"","border":"left"}},[_vm._v(" Faktura förföll för "+_vm._s(_vm.oldestDeprecatedInvoice.age)+" dagar sedan. ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }